import * as React from "react";
import type { AllTrueChangeObservable } from "@glide/support";

export const InputsValidContext = React.createContext<AllTrueChangeObservable<unknown> | undefined>(undefined);

export const InputsValidContextProvider = InputsValidContext.Provider;
